import React, { useRef, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import PopUp from '../../../../common/components/PopUp/PopUp';
import HomeLoanDetails from './HomeLoanDetails';
import HomeLoanCards from './HomeLoanCards';
import { useFormikWizard } from 'formik-wizard';
import { getBt } from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
const AddHomeLoan = () => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    isSubmitting,
    resetForm
  } = useFormikContext();
  const { values: wizardValues } = useFormikWizard();
  const [noOfUploadeneeded, setNoOfUploads] = useState('');
  const [steps, setSteps] = useState('');
  const [dataView, setDataView] = useState([]);
  const [show, setShow] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('init');
  const [indexVal, setIndexVal] = useState(1);
  const [getSavedData, setTogetdata] = useState([]);
  const [btnEnable, setBtnEnable] = useState(false);
  const [sactionDocId, setSactionDocId] = useState(null);
  const [statmentDocId, setStatementDocId] = useState(null);
  const [updateAPI, setUpdateAPI] = useState(false);
  const [loanId, setLoanId] = useState(null);
  const [getShowButton, setGetShowButton] = useState(true);
  const [property, setProperty] = useState(values.selectedSubProperty());
  const [loanType, setLoanType] = useState(values.selectedProperty());

  const saveLoanDetails = async () => {
    setSteps('showLoanDetails');
  };

  useEffect(() => {
    const handleOnProps = async () => {
      if (loanType === 'Plot+Construction') {
        await setFieldValue('addNewLoan', false);
        await handleSubmit();
      } else if (
        loanType != 'Balance Transfer + Top Up' &&
        loanType != 'Balance Transfer'
      ) {
        await setFieldValue('addNewLoan', false);
        handleSubmit();
      }
    };
    handleOnProps();
  }, []);
  useEffect(() => {
    setShow(true);
    setPopUpType('loading');
    setPopUpText('Fetching the Loan Details ...');
    let applicant = getApplicantionInfo();
    getBt(applicant.leadId)
      .then(res => {
        let data = {
          id: res?.obligationId,
          lender: res?.bankName,
          propertyValue: res?.propertyMarketValue,
          interestRate: res?.currentRateOfInterest,
          sanctionAmount: res?.sanctionedAmount,
          balanceAmount: res?.outstandingAmount,
          totalTenure: res?.totalTenure,
          balanceTenure: res?.balanceTenure
        };
        setTogetdata([data]);
        setSteps('showLoanDetails');
        setShow(false);
      })
      .catch(err => {
        if (err?.response?.data?.status == 400) {
          setSteps('showSavedLoanView');
          setShow(false);
        } else {
          setPopUpType('fail');
          setPopUpText(
            err?.response?.data?.message ||
              'something gone wrong!please try again..'
          );
        }
      });
  }, []);
  return (
    <div className="w-full  mr-auto  block px-5 py-4 bg-white ">
      {steps == 'showLoanDetails' ? (
        <React.Fragment>
          <div className="w-full py-3 my-1">
            <HomeLoanDetails
              values={values}
              data={data}
              setData={setData}
              handleChange={handleChange}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              name={name}
              setFileUploadErrors={setFileUploadErrors}
              fileUploadErrors={fileUploadErrors}
              setFieldTouched={setFieldTouched}
              handleSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              setSteps={setSteps}
              setPopUpType={setPopUpType}
              setPopUpText={setPopUpText}
              setShow={setShow}
              setSactionDocId={setSactionDocId}
              setStatementDocId={setStatementDocId}
              setUpdateAPI={setUpdateAPI}
              setLoanId={setLoanId}
              getSavedData={getSavedData}
              wizardValues={wizardValues}
            />
            {isSubmitting ||
            values.lenderName == '' ||
            errors.lenderName ||
            errors.propertyValue ||
            values.propertyValue == '' ||
            values.sanctionAmount == '' ||
            errors.sanctionAmount ||
            errors.balanceAmount ||
            values.balanceAmount == '' ||
            values.totalTenure == '' ||
            errors.totalTenure ||
            errors.balanceTenure ||
            values.balanceTenure == '' ||
            errors.interestRate ||
            values.interestRate == '' ? null : (
              <div className="w-full clear-both py-4">
                <button
                  type="button"
                  className="submitButton font-roboto text-white text-base w-48 my-0 "
                  onClick={async () => {
                    handleSubmit();
                  }}
                >
                  NEXT
                </button>
              </div>
            )}
          </div>
        </React.Fragment>
      ) : null}
      {steps == 'showSavedLoanView' ? (
        <React.Fragment>
          <HomeLoanCards
            handleChange={handleChange}
            errors={errors}
            touched={touched}
            handleBlur={handleBlur}
            setFieldError={setFieldError}
            setFieldValue={setFieldValue}
            name={name}
            handleSubmit={handleSubmit}
            values={values}
            setSteps={setSteps}
            setTogetdata={setTogetdata}
            setShow={setShow}
            setIndexVal={setIndexVal}
            setPopUpType={setPopUpType}
            setPopUpText={setPopUpText}
            setGetShowButton={setGetShowButton}
            setBtnEnable={setBtnEnable}
          />
          {getShowButton ? (
            <div className="w-full clear-both py-4">
              <button
                type="button"
                className="submitButton font-roboto text-white text-base w-48 my-0 "
                onClick={async () => {
                  await setFieldValue('addNewLoan', false);
                  handleSubmit();
                }}
              >
                NEXT
              </button>
            </div>
          ) : (
            <PageButton
              setSteps={setSteps}
              onclik={saveLoanDetails}
              btnEnable={btnEnable}
            />
          )}
        </React.Fragment>
      ) : null}
      <PopUp type={popUpType} text={popUpText} setShow={setShow} show={show} />
    </div>
  );
};
const PageButton = props => {
  const { setSteps, onclik, btnEnable } = props;
  return (
    <div
      className="w-full flex items-center h-20 mx-auto clear-both"
      style={{ width: 'fit-content' }}
    >
      <button
        type="button"
        disabled={!btnEnable}
        className="submitButton font-roboto text-white text-base w-48 my-0 "
        style={{ marginLeft: '10px', marginRight: '10px' }}
        onClick={() => {
          onclik();
        }}
      >
        Add
      </button>
    </div>
  );
};

export default AddHomeLoan;
